import React from 'react';
import {WifiOff} from 'lucide-react';
import type {SignalRConnectionState} from '../hooks/useSignalRGroupHub';

const ConnectionStatusBar: React.FC<{
    connectionState: SignalRConnectionState;
    hasThread: boolean;
}> = ({connectionState, hasThread}) => {
    if (!hasThread || connectionState === 'Connected') {
        return null;
    }

    return (
        <div className="alert alert-warning py-1 px-2 small d-flex align-items-center gap-2 mb-2">
            <WifiOff size={14} />
            {connectionState === 'Reconnecting'
                ? 'Reconnecting…'
                : 'Connecting to live updates…'}
        </div>
    );
};

export default ConnectionStatusBar;
